import { render, staticRenderFns } from "./CreateOwn.vue?vue&type=template&id=41daeb5f&lang=html"
import script from "./CreateOwn.vue?vue&type=script&lang=js"
export * from "./CreateOwn.vue?vue&type=script&lang=js"
import style0 from "./CreateOwn.vue?vue&type=style&index=0&id=41daeb5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports